import { enqueueAutoTagWorkbook } from "@/apis/table/route";
import queries from "@/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useWorkbookId } from "../use-workbook";
import { notifyAutoTagStartFailure } from "./auto-tag-error";

/**
 * 워크북 전체 오토태깅을 표당 Cloud Task 로 백그라운드 enqueue.
 *
 * enqueue 는 202 로 즉시 끝나고 실제 작업은 백그라운드에서 돈다. 진행상황은
 * `useAutoTagStatus` 폴링으로 노출하므로 여기서는 시작 트리거만 담당한다.
 */
export const useAutoTagWorkbook = () => {
  const { data: workbookId } = useWorkbookId();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["auto-tag-workbook", workbookId],
    mutationFn: async () => {
      if (!workbookId) throw new Error("Workbook ID is not found");
      return enqueueAutoTagWorkbook(workbookId);
    },
    onSuccess: (data) => {
      if (!workbookId) return;
      // 실제 enqueue 된 수를 보여준다 — 일반사항·회계정책·추정 등 목차의 표는 서버가 빼므로 "전체"와 어긋날 수 있다.
      toast.success(`표 ${data.enqueued}개의 오토태깅을 시작했습니다.`);
      // promise 반환 → status refetch(PENDING 도착)까지 isPending 유지(깜빡임 방지).
      return queryClient.invalidateQueries(
        queries.workbook(workbookId)._ctx.autoTagStatus(),
      );
    },
    onError: notifyAutoTagStartFailure,
  });

  return { mutate, isPending };
};
